import React, { Fragment } from "react";
import { useState, useEffect, useRef,useMemo } from "react";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { loadSanadBranding } from "../utils/loadSanadBranding";
import SanadMotorInsuracePolicy from "./SanadMotorInsurace";
import SanadMotorPolicyRenewal from "./SanadMotorPolicyRenewal";

const { config } = require("../../api/api");

const SanadMotorHandler = () => {

const [activeButton,setActiveButton]=useState(1);

   const handleClick = (buttonId) => {
              setActiveButton(buttonId);

              

            }

    
  useEffect(() => {
    loadSanadBranding();
  }, []);

    return(
        <>
        <div>
             <div className="mt-3 ml-2 ml-md-3 ">
          <h1>Motor Insurance</h1>
        </div>
        <div className="row ml-2 ml-md-3 ">

             <div className="col-11 col-md-6 my-4 d-flex p-0">
               
              <button
                className="w-50"
                style={{
                  padding: "10px 10px",
                  border: "1px solid #073e78",
                  borderRadius: "6px 0px 0px 6px",
                  backgroundColor: activeButton === 1 ? "#073e78" : "white",
                  color: activeButton === 1 ? " white" : "#073e78",
                }}
                onClick={() => handleClick(1)}
              >
                <div>Buy Policy</div>
              </button>
             
           
              <button
                className="w-50"
                style={{
                  padding: "10px 10px",
                  border: "1px solid #073e78",
                  borderRadius: "0px 6px 6px 0px",
                  backgroundColor: activeButton === 2 ? " #073e78" : "white",
                  color: activeButton === 2 ? " white" : "#073e78",
                }}
                onClick={() => handleClick(2)}
              >
                <div>Renewal Policy</div>
              </button>
              
            </div>
        </div>{

activeButton==1?
        
            <SanadMotorInsuracePolicy  />
:activeButton==2?
            <SanadMotorPolicyRenewal />:
            <></>
        }
        </div>
        </>
    )
}

export default SanadMotorHandler;